module.exports = __webpack_public_path__ + "static/img/tu2.8790d4f4.png";